const state = {
  id: undefined,
  name: ""
};

const mutations = {
  SET_COMPANY_INFO: (state, info) => {
    state.id = info.id;
    state.name = info.companyName;
  }
};

const actions = {
  setCompanyInfo({ commit }, info) {
    commit("SET_COMPANY_INFO", info);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
